export const stringToPascalCase = (str: string) =>
  str.replace(
    /(\w)(\w+)/,
    (_, groupOne, groupTwo) => groupOne.toUpperCase() + groupTwo.toLowerCase()
  );
